import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", {
  state: () => ({
    is_full_screen: false, // 是否是全屏
    hasHomeIndicator: false, // 是否是全面屏
    apps: [],
    ads: [],
    share_title: "", //分享标题
    superiors_dividends_desc: "", // 分红说明
    enable_human_verification: true, // 是否启用人机验证，后端明确下发 false 时关闭
    turnstile_site_key: "", // Turnstile site key
    about_text: "", //关于我们
    banner_list: [], // 首页底部轮播图
    swipe_duration: 3, // 轮播切换间隔，单位为秒
    contact_us: [], // 底部联系我们模块的图标和跳转配置
    contact_us_title: "", // 底部联系我们模块标题
    ga_id: "",
    ad_config: {
      //广告配置
      adLink: "", //广告链接
      rewardAmount: 0, //奖励
      adFrequency: 0, //频率(小时)
    },
    check_in_config: {
      //签到1-7天分别奖励
      day1: 0,
      day2: 0,
      day3: 0,
      day4: 0,
      day5: 0,
      day6: 0,
      day7: 0,
    },
    welcome_reward: {
      // 欢迎页面随机奖励
      min: 0,
      max: 0,
    },
    user_reward: {
      // 邀请奖励
      regularCoin: 0, //普通金币
      regularBalance: 0, //普通余额
      vipCoin: 0, //会员金币
      vipBalance: 0, //会员余额
    },
    app_link: "", //小程序自身链接
    Phone_url: "", //绑定手机号链接
    bot_username: "", //bot用户名
    coin_name: "", //挖的币名字
    coin_image: "", //挖的币图标
    coin_yield: "", //每秒产出
    claim_limit: "", //最低领取限制
    app_coin_name: "", //自身币名字
    app_coin_image: "", //自身币图标
    app_coin_desc: "", //自身币描述
    fan_image: "", //点点点图片
    welcome_image: "", //欢迎图片
    welcome_connect: false, //是否需要连接钱包
    themes_color: "", //主题色
    partner_image: "", //合作伙伴
    miner_list: [], //矿机列表
    withdraw_fee: "", //网络手续费
    project_name: "", //项目名字
    whitelist: "", //白名单
    auto_pause_mining: "", //超过n天没使用，自动暂停。单位: 天
    withdraw_amount: {
      //随机提现
      min: 0,
      max: 0,
    },
    miniapp_info: {}, // 小程序头部信息
    ton_connect: {}, // 小程序连接钱包信息
    coin_data: {
      price: 0,
      symbol: "",
    }, // 币的价格
    coin_data_error: false, // 币的价格是否错误
    ton_address: "", //ton地址
    miner_max: 0, // 每个装备最多可以购买的数量
    short_domain: "", //短链接的域名
    withdraw_chain: "", //提现的链
    withdraw_limit_v1: 0, //提现阶级[{key_name: 0, key_val: 0}]
    withdraw_bind: 0, //提现任务人数
    max_share_count: 0, //最大分享人数
    miner_font_color: "", //矿机字体颜色
    miner_bg_image: "", //矿机背景图片
    welcome_text: [], //欢迎模块的文字
    min_commission: 0, //最小限制
    question_list: [], //FAQ列表
    wallet_reward: "", //绑定钱包奖励
    sponsor_list: [], //赞助商列表
    commission_config: [], //佣金配置
    first_withdraw_limit_tip: "", //首次提现限制提示
    withdraw_limit_tip: "", //提现限制提示
    denominated_coin: "", //提现币种
    withdraw_mode: "", //提现模式
    pay_skip_tip: "", //支付跳转提示
    withdraw_step: "", //提现步骤
    withdraw_ladder: "", //提现阶梯
    share_domain: "", //分享域名
    coin_list: [], //币种列表
    miniapp_enable: "", //是否是小程序
    user_reward: "", //邀请奖励
    invite_text: "", //邀请文字,
    invite_not_enough_text: "", //邀请不足文字
    miner_exchange_success_text: "", //矿机兑换成功文字
    scan_coin_name: "", //扫描币种名字
    coin_exchange_name: "", //币种交易所名字
    invoice_list: [], // 支付列表
    post_link: "", // 分享链接
    progress_start: "", // 进度开始
    progress_text: "", // 进度文本
    accelerated_step: [], // 加速步骤
    over_task_text: "", // 任务结束文字
    // 用于存储可能的额外属性
    extraConfig: {},
  }),
  actions: {
    setApps(apps) {
      this.apps = apps;
    },
    setAds(ads) {
      this.ads = ads;
    },
    setBannerList(list) {
      this.banner_list = Array.isArray(list) ? list : [];
    },
    setCoinData(data) {
      this.coin_data = data;
    },
    setCoinDataError(error) {
      this.coin_data_error = error;
    },
    setDATA(data) {
      for (const key in data) {
        if (key in this.$state) {
          this[key] = data[key];
        } else {
          // 对于state中未定义的属性，将其添加到extraConfig中
          this.extraConfig[key] = data[key];
        }
      }
    },
    // 添加一个安全的方法来获取配置值
    getConfig(key) {
      if (key in this.$state) {
        return this[key];
      } else if (key in this.extraConfig) {
        return this.extraConfig[key];
      }
      return undefined;
    },
    setShareDomain(data) {
      this.share_domain = data;
    },
  },
});
